// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
import reactUpdate from 'immutability-helper';
import _ from 'underscore';

import {StandardDNACodon} from 'biojs/Codons';
import {EventConstants} from 'constants/EventConstants';
import AppDispatcher, {FluxAction} from 'lib/Dispatcher';
import Store from 'lib/Store';

class OrganismStore extends Store {
  organismIdToCodonUsage!: {[organismId: number]: Record<StandardDNACodon, number>};

  override resetState(): void {
    this.organismIdToCodonUsage = {};
  }

  getCodonUsage(organismId: number): Record<StandardDNACodon, number> {
    return this.organismIdToCodonUsage[organismId];
  }

  override payloadHandler(action: FluxAction): boolean {
    switch (action.actionType) {
      case EventConstants.ORGANISM_CODON_USAGE_FETCH:
        this.organismIdToCodonUsage = reactUpdate(this.organismIdToCodonUsage, {
          $merge: _.object([[action.organismId, action.codonUsage]]),
        });
        this.emitChange();
        break;
      default:
        break;
    }
    return true;
  }
}

export default new OrganismStore(AppDispatcher);
